// Scrolls to just above paginated results (when results container has id 'results-container')
document.addEventListener('DOMContentLoaded', () => {
  // Abort if user has scrolled before this fires
  if (window.scrollY) return;

  if (window.location.pathname.includes('/page/')) {
    const scrollToEl = document.querySelector('#results-container');
    window.scrollTo(0, scrollToEl.offsetTop - 40);
  }
});
